// eslint-disable-next-line import/prefer-default-export
export const maxBoxWaitDelayForOnSiteAutomation = 120;
